(function() {
  'use strict';

  var ticking = false;
  var mainCheckoutObserver = null;
  var bodyObserver = null;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function hideLegacyUpsellBanner() {
    document.querySelectorAll('.cart-upsell-row').forEach(function(row) {
      row.hidden = true;
    });

    document.querySelectorAll('.cart-upsell-banner').forEach(function(banner) {
      var row = banner.closest('.cart-upsell-row');
      if (row) {
        row.hidden = true;
      } else {
        banner.hidden = true;
      }
    });
  }

  function isMainCheckoutVisible(mainCheckout) {
    if (!mainCheckout) return false;

    var rect = mainCheckout.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    var visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    var visibleWidth = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
    var requiredHeight = Math.min(40, rect.height * 0.45);

    return visibleHeight >= requiredHeight && visibleWidth > 0;
  }

  function isApplePayLikely() {
    var ua = navigator.userAgent || '';
    var platform = navigator.platform || '';
    var isAppleDevice = /iPhone|iPad|iPod/.test(ua) || /Mac/.test(platform) || /Macintosh/.test(ua);
    return isAppleDevice && 'ApplePaySession' in window;
  }

  function isGooglePayLikely() {
    var ua = navigator.userAgent || '';
    var isAndroid = /Android/.test(ua);
    var isChrome = /Chrome|CriOS/.test(ua) && !/Edg|OPR|SamsungBrowser/.test(ua);
    return isAndroid || isChrome;
  }

  function getWalletContent(panel) {
    var text = (panel.textContent || '').toLowerCase();
    var html = (panel.innerHTML || '').toLowerCase();
    var hasApplePay = text.indexOf('apple pay') !== -1 || html.indexOf('apple_pay') !== -1 || html.indexOf('apple-pay') !== -1 || isApplePayLikely();
    var hasGooglePay = text.indexOf('google pay') !== -1 || html.indexOf('google_pay') !== -1 || html.indexOf('google-pay') !== -1 || isGooglePayLikely();
    var hasShopPay = text.indexOf('shop pay') !== -1 || html.indexOf('shop_pay') !== -1 || html.indexOf('shop-pay') !== -1;
    var walletCount = (hasApplePay ? 1 : 0) + (hasGooglePay ? 1 : 0) + (hasShopPay ? 1 : 0);

    if (walletCount > 1) {
      return {
        label: 'かんたん・安心のクイック決済',
        copyHtml: '対応している方法を選ぶと、<wbr>住所やカード情報の<wbr>入力を省いて<wbr>購入できます。'
      };
    }

    if (hasApplePay) {
      return {
        label: 'Apple Payでかんたん決済',
        copyHtml: '住所やカード情報の<wbr>入力を省いて、<wbr>安心して<wbr>購入できます。'
      };
    }

    if (hasGooglePay) {
      return {
        label: 'Google Payでかんたん決済',
        copyHtml: '住所やカード情報の<wbr>入力を省いて、<wbr>安心して<wbr>購入できます。'
      };
    }

    if (hasShopPay) {
      return {
        label: 'Shop Payでかんたん決済',
        copyHtml: '登録済みの情報を使って、<wbr>スムーズに<wbr>購入できます。'
      };
    }

    return {
      label: 'かんたん・安心のクイック決済',
      copyHtml: '対応している場合、<wbr>住所やカード情報の<wbr>入力を省いて<wbr>購入できます。'
    };
  }

  function updateWalletPanelLabels() {
    document.querySelectorAll('[data-cart-wallets-panel]').forEach(function(panel) {
      var label = panel.querySelector('[data-cart-wallets-label]');
      var copy = panel.querySelector('[data-cart-wallets-copy]');
      var content = getWalletContent(panel);

      if (label && label.textContent !== content.label) label.textContent = content.label;
      if (copy && copy.innerHTML !== content.copyHtml) copy.innerHTML = content.copyHtml;
    });
  }

  function isStickyCheckoutUsable(stickyCheckout) {
    if (!stickyCheckout || stickyCheckout.classList.contains('is-hidden-by-main-cta')) return false;
    if (!window.matchMedia('(max-width: 749px)').matches) return false;

    var style = window.getComputedStyle(stickyCheckout);
    var rect = stickyCheckout.getBoundingClientRect();

    return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
  }

  function isAnyPrimaryCheckoutVisible() {
    var primaryCheckouts = document.querySelectorAll('.cart-priority-checkout__button, #checkout.cart__checkout-button');
    for (var i = 0; i < primaryCheckouts.length; i++) {
      if (isMainCheckoutVisible(primaryCheckouts[i])) return true;
    }
    return false;
  }

  function syncFloatingMenuPosition(stickyCheckout) {
    var floatingMenu = document.getElementById('FloatingMenuBtn');
    if (!floatingMenu || !isStickyCheckoutUsable(stickyCheckout)) {
      document.documentElement.style.removeProperty('--cart-floating-menu-bottom');
      return;
    }

    var stickyHeight = Math.ceil(stickyCheckout.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--cart-floating-menu-bottom', Math.max(stickyHeight + 12, 72) + 'px');
  }

  function updateCartFlow() {
    ticking = false;

    if (document.body) document.body.classList.add('maima-cart-flow-ready');
    hideLegacyUpsellBanner();
    updateWalletPanelLabels();

    var stickyCheckout = document.querySelector('.cart-sticky-checkout');
    var mainVisible = isAnyPrimaryCheckoutVisible();

    if (stickyCheckout) stickyCheckout.classList.toggle('is-hidden-by-main-cta', mainVisible);
    syncFloatingMenuPosition(stickyCheckout);
  }

  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateCartFlow);
  }

  function observeMainCheckout() {
    if (mainCheckoutObserver) mainCheckoutObserver.disconnect();
    if (!('IntersectionObserver' in window)) return;

    var mainCheckouts = document.querySelectorAll('.cart-priority-checkout__button, #checkout.cart__checkout-button');
    if (!mainCheckouts.length) return;

    mainCheckoutObserver = new IntersectionObserver(scheduleUpdate, {
      threshold: [0, 0.2, 0.45, 0.75, 1],
    });
    mainCheckouts.forEach(function(button) {
      mainCheckoutObserver.observe(button);
    });
  }

  function init() {
    scheduleUpdate();
    observeMainCheckout();

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);

    if (document.body && 'MutationObserver' in window) {
      bodyObserver = new MutationObserver(function() {
        scheduleUpdate();
        observeMainCheckout();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    window.setTimeout(scheduleUpdate, 250);
    window.setTimeout(scheduleUpdate, 1000);
  }

  ready(init);
})();
